var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"facebook-signup btn btn-block",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.login.apply(null, arguments)}}},[_c('img',{attrs:{"src":require(`@assets/img/facebook-f-${_vm.iconColor}.svg`),"alt":"Facebook"}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }